import { Navigate } from 'react-router-dom';

function PrivateRoute({ element }) { 
const isloggedIn = localStorage.getItem('access_token');  
  return isloggedIn ? element : <Navigate to="/" />;
}

export default PrivateRoute;